import React from 'react'
import Icon from './Icon'

/* eslint-disable import/prefer-default-export */
export function withIcon (IconComponent) {
  return function WrappedIcon (props) {
    const {
      size = 24,
      color = 'currentColor',
      className,
      ...restProps
    } = props

    return (
      <Icon size={size} color={color} className={className}>
        <IconComponent {...restProps} />
      </Icon>
    )
  }
}
